import React from 'react'
import { EyeIcon } from './Icons'
import { formatCompactNumber } from '../../../utils'

export const CustomTooltip = ({
  active,
  payload,
  showIncomePolygonData,
  singlePolygonData,
  rightSidebarStore,
  uiStore,
  onKeepHighlight,
  onDropHighlight,
  onTooltipEnter,
  onTooltipLeave,
  position = 'left'
}) => {
  // Handle polygon highlighting moved to EconomicStrengthSection Scatter/Cell handlers
  // to prevent render loops/shaking

  if (active && payload && payload.length) {
    const data = payload[0].payload
    const isTargetGroup = data.id === 0 && !showIncomePolygonData && !singlePolygonData
    const population = data.population || 0
    const income = data.income || 0
    const name = data.name
    const showFolderViewButton = !isTargetGroup && !singlePolygonData
    const isFolderViewDisabled = false

    // Calculate inline style based on position
    const getPositionStyle = () => {
      const spacing = 15 // Gap between point and tooltip
      switch (position) {
        case 'right':
          return { transform: `translate(${spacing}px, -50%)` }
        case 'top':
          return { transform: `translate(-50%, calc(-100% - ${spacing}px))` }
        case 'bottom':
          return { transform: `translate(-50%, ${spacing}px)` }
        case 'left':
        default:
          return { transform: `translate(calc(-100% - ${spacing}px), -50%)` }
      }
    }

    // Always position tooltip to the left of the cursor/point to show fully
    return (
      <div className='income-data-sidebar__tooltip-wrapper'>
        {/* Bridge area to make it easier to move mouse from dot to tooltip */}
        {/* <div
          onMouseEnter={(e) => {
            e.stopPropagation()
            if (onTooltipEnter) {
              onTooltipEnter()
            }
          }}
          onMouseLeave={(e) => {
            e.stopPropagation()
            // If mouse leaves bridge without entering tooltip, hide after small delay
            setTimeout(() => {
              if (onTooltipLeave) {
                onTooltipLeave()
              }
            }, 10)
          }}
          className="income-data-sidebar__tooltip-bridge"
        /> */}
        <div
          onMouseEnter={(e) => {
            e.stopPropagation()
            if (onTooltipEnter) {
              onTooltipEnter()
            }
          }}
          onMouseLeave={(e) => {
            e.stopPropagation()
            if (onTooltipLeave) {
              onTooltipLeave()
            }
          }}
          style={getPositionStyle()}
          className={`income-data-sidebar__tooltip-container income-data-sidebar__tooltip-container--${position}`}
        >
          {/* Shape Name Header */}
          {!isTargetGroup && name && (
            <div className='income-data-sidebar__tooltip-shape-header'>
              {name}
            </div>
          )}
          {/* Population Section */}
          <div className='income-data-sidebar__tooltip-data-section'>
            <span className='income-data-sidebar__tooltip-data-label'>
              Population
            </span>
            <span className='income-data-sidebar__tooltip-data-value'>
              {formatCompactNumber(population)}
            </span>
          </div>

          {/* Income Section */}
          <div className='income-data-sidebar__tooltip-data-section'>
            <span className='income-data-sidebar__tooltip-data-label'>
              Income
            </span>
            <span className='income-data-sidebar__tooltip-data-value'>
              {formatCompactNumber(income, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
            </span>
          </div>

          {/* See Individual Shapes Button */}
          {isTargetGroup && (
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (e.nativeEvent) {
                  e.nativeEvent.stopImmediatePropagation()
                }
                rightSidebarStore.showIncomeIndividualShapes()
              }}
              className='income-data-sidebar__tooltip-button'
            >
              <EyeIcon />
              <span className='income-data-sidebar__tooltip-button-text'>
                See individual shapes
              </span>
            </button>
          )}

          {/* See Folder View Button */}
          {showFolderViewButton && (
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (e.nativeEvent) {
                  e.nativeEvent.stopImmediatePropagation()
                }
                if (isFolderViewDisabled) {
                  return
                }
                if (rightSidebarStore && rightSidebarStore.targetGroupId && rightSidebarStore.targetGroupName) {
                  rightSidebarStore.fetchPopulationDataForTargetGroup(
                    rightSidebarStore.targetGroupId,
                    rightSidebarStore.targetGroupName
                  )
                }
              }}
              className={`income-data-sidebar__tooltip-button${isFolderViewDisabled ? ' income-data-sidebar__tooltip-button--disabled' : ''}`}
              disabled={isFolderViewDisabled}
            >
              <EyeIcon />
              <span className='income-data-sidebar__tooltip-button-text'>
                See Folder View
              </span>
            </button>
          )}
        </div>
      </div>
    )
  }
  return null
}
